export const Instructor = {
  getAll: () => {
    return [
      {
        id: 'rao',
        name: 'RAO',
        subtitle: 'Danza Acrobática',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-danza-acrobatica.jpg',
        description: 'Danza al estilo RAO.',
        slug: '/instructores/rao/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-rao.jpg',
        social: {
          fb: [{
            name: 'roberto.aguilarortiz.92',
            link: 'https://www.facebook.com/roberto.aguilarortiz.92',
          }],
          ig: [{
            name: 'RAO',
            link: 'https://www.instagram.com/aguilarortizroberto/',
          }],
        },
        about: '<p>Roberto Aguilar Ortiz, <strong>RAO</strong>, es un bailarín y acróbata profesional, artista multi-disciplinario con conocimientos en Danza y Artes del Circo.</p><p>Ha participado en diferentes eventos dancísticos como Valle de la Luna, Día Internacional de la Danza, Interdance, Reyes del Asfalto, Battle Sonic, entre otros.</p><p>Así también, ha impartido varios cursos y talleres como: <ul><li>Taller de Principios de Contorsión</li><li>Taller de Danza Aerea en Tela</li><li>Taller Método RAO "La Simetría del Flow" (Entrenamiento para acróbatas y bailarines)</li></ul></p><p><strong>Especialidades</strong><ul><li>Cyr Wheel</li><li>Danza Aerea (Telas, Aros, Cintas)</li><li>Acrobacia</li><li>Danza Contemporanea</li><li>Break Dance</li><li>Hip Hop</li></ul></p><p><strong>Método RAO</strong></p><p>Es un conjunto de técnicas de danza y métodos acrobáticos.</p><p>El desarrollo de este método tiene como finalidad, el poder brindar al estudiante, herramientas como la fuerza, la flexibilidad, coordinación, control y fluidez corporal.</p><p>Técnicas de danza conteporanea como Graham, Reléase, Horton, Animal Flow, se hacen presentes en este método, buscando movimientos angulares, en contracción, relajacion y alargamiento del cuerpo. Así mismo se combina la gimnasia, la flexibilidad, la postura, las posiciones básicas de ballet entre otros elementos.</p>',
      },
      {
        id: 'alma-y-cesar',
        name: 'Alma y Cesar',
        subtitle: 'Ritmos Latinos',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-ritmos-latinos.jpg',
        description: 'Aprende a bailar con esta pareja de instructores profesionales.',
        slug: '/instructores/alma-y-cesar/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-alma-y-cesar.jpg',
        social: {
          fb: [{
            name: 'Alma Castro',
            link: 'https://www.facebook.com/aalmaa.caastroo',
          },
          {
            name: 'Cesar Zamudio',
            link: 'https://www.facebook.com/profile.php?id=100007195514885',
          }],
          ig: [{
            name: 'Cesar Zamudio',
            link: 'https://www.instagram.com/c3sarz4m_b3llas/',
          }],
        },
        about: '',
      },
      {
        id: 'johnatan',
        name: 'Johnatan',
        subtitle: 'Yoga',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-yoga.jpg',
        description: 'Todo sobre relajación, flexibilidad y respiración.',
        slug: '/instructores/johnatan/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-johnatan.jpg',
        social: {
          fb: [{
            name: 'Yoga & Pole',
            link: 'https://www.facebook.com/YogaPole-104680707591441/',
          },]
        },
        about: 'Fiel creyente de la disciplina y el autoconocimiento. Johnatan desde muy pequeño creció haciendo ejercicio y practicando un sinfin de actividades físicas desde la gimnasia hasta el futbol, logrando llegar a varias competencias nacionales en diversas disciplinas.<br><br>En 2012 como practicante de artes circenses descubre a través de amigos la existencia del acroyoga y empieza a practicarlo de forma autodidacta.<br><br>No fue sino hasta 2014 cuando emprende el camino para prepararse como instructor de yoga y funcional training, logra certificarse ante LAYLA (asociación de instructores de yoga de Latinoamérica) y desde entonces ha sido instructor en diferentes centros de desarrollo deportivo y estudios de yoga, impartiendo clases y talleres.<br><br>En 2019 tomó el teacher training con Rachel Tome y Franz Godet.',
      },
      {
        id: 'guillo',
        name: 'Guillo',
        subtitle: 'Gimnasia',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-gimnasia.jpg',
        description: 'Fortalecete y domina tu cuerpo con los mejores tips de gimnasia.',
        slug: '/instructores/guillo/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-guillo.jpg',
        social: {
          ig: [{
            name: 'kublahkraus',
            link: 'https://www.instagram.com/kublahkraus/',
          },]
        },
        about: '<p><strong>Guillo</strong> es un ex-gimnasta competitivo con más de 16 años en el medio, entrenador profesional a tiempo completo que lidera con pasión durante más de 10 años.</p><p>Experiencia trabajando con niños desde 6 años hasta adultos de 50 años.<br>Experiencia trabajando con atletas no gimnastas como TaeKwonDo, Karate, Cheerleading, HipHop Dancers, Contempo Dancers, Jazz Dancers, Circus Artists y más, ayudándoles a desarrollar condición y acrobacias.</p><p>Especialidad en crear y desarrollar programas de entrenamiento a Nivel principiantes y competitivos, tanto en Gimnasia Varonil cómo Femenil.</p><p>Participación en campeonatos interclubes, estatales, Estatal Elite y nacionales.</p>',
      },
      {
        id: 'mary-y-john',
        name: 'Mari y John',
        subtitle: 'AcroYoga',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-acroyoga.jpg',
        description: 'Trabaja y refuerza la confianza en pareja. Diviértete practicando este estilo de Yoga.',
        slug: '/instructores/mary-y-john/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-acroyoga.jpg',
        social: {
          fb: [{
            name: 'Yoga & Pole',
            link: 'https://www.facebook.com/YogaPole-104680707591441/',
          },]
        },
        about: '<strong>Mari</strong><br><br>Apasionada del ejercicio, Maricruz inicio su gusto por la práctica deportiva a través de correr y hacer trekking, posteriormente inició la práctica del acroyoga con Johnatan Estrada y desde ahí no ha dejado de practicar y crecer en esta disciplina.<br><br> Dos años después de iniciar su práctica de acroyoga, decide tomar clases de pole dance, en donde encuentra un gusto que transformaría en profesión, en 2017 decide certificarse como instructora de pole dance ante la Asociación Nacional de Pole Dance en México y ante la SEP, desde entonces se ha desarrollado como instructora en diferentes estudios y ha tomado clases con excelentes profesionales del pole dance como Olena Minina, Fafa Xtxeverria, Roberto Ortiz, Citlalli León, Ismael Guerrero, entre otros.<br><br> Y en el ámbito del acroyoga, tomó en 2019 un teacher training con el duoaweake conformado de Rachel Tome y Franz Godet. <br><br>Actualmente está desarrollando un estilo propio de acroyoga involucrando figuras del pole dance con las bases del acroyoga.<br><br><br><br><strong>John</strong><br><br>Fiel creyente de la disciplina y el autoconocimiento. Johnatan desde muy pequeño creció haciendo ejercicio y practicando un sinfin de actividades físicas desde la gimnasia hasta el futbol, logrando llegar a varias competencias nacionales en diversas disciplinas.<br><br>En 2012 como practicante de artes circenses descubre a través de amigos la existencia del acroyoga y empieza a practicarlo de forma autodidacta.<br><br>No fue sino hasta 2014 cuando emprende el camino para prepararse como instructor de yoga y funcional training, logra certificarse ante LAYLA (asociación de instructores de yoga de Latinoamérica) y desde entonces ha sido instructor en diferentes centros de desarrollo deportivo y estudios de yoga, impartiendo clases y talleres.<br><br>En 2019 tomó el teacher training con Rachel Tome y Franz Godet.',
      },
      {
        id: 'angie-campirano',
        name: 'Angie Campirano',
        subtitle: 'Flex',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-flex.jpg',
        description: 'Flexibilidad y elongación de tus músculos, tendones y articulaciones.',
        slug: '/instructores/angie-campirano/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-angie-campirano.jpg',
        social: {
          fb: [{
            name: 'Angie Campirano',
            link: 'https://www.facebook.com/angie.lopezcampirano',
          },],
          ig: [{
            name: 'angielopezcampirano',
            link: 'https://www.instagram.com/angielopezcampirano/',
          },],
        },
        about: '<p>Estudió la Licenciatura en Ciencias del Ejercicio, por parte de la Universidad Autónoma de Nuevo León</p><p>Ha sido instructora de Danza Aérea en la Academia de Artes Circenses Patlani, el Foro Cultural Dos Lunas, el club Sportika, entre otros.</p><p><strong>Participación en Eventos</strong></p><ul><li>Primer lugar en resistencia en Dips en Calistenics Elite Wars edición 2019</li><li>Primer lugar en resistencia en Dips en el evento Battle of the Bars edición Guadalajara</li><li>Participación como artista invitado en el Festival Valle de la Luna edición 2019</li><li>Primer lugar en gimnasia artística nivel obligatorio 1, en la Copa Estado de México, 2017</li><li>Participación como artista Invitado en la Obra Circus Magic 2016 Zentrika, Santa Fe</li></ul></p>',
      },
      {
        id: 'ekbars',
        name: 'EK Bars',
        subtitle: 'Calistenia',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-calistenia.jpg',
        description: 'Entrena Calistenia con los mejores coaches de EK Bars.',
        slug: '/instructores/ekbars/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-ekbars.jpg',
        social: {
          fb: [{
            name: 'EK Bars',
            link: 'https://www.facebook.com/eklektos.workout/',
          },],
          ig: [{
            name: 'EK Bars',
            link: 'https://www.instagram.com/ek_bars/',
          },
          {
            name: 'Coach Emma',
            link: 'https://www.instagram.com/leo_ekbars/',
          },
          {
            name: 'Coach Luis Ángel',
            link: 'https://www.instagram.com/fozzy_ekbars/',
          },
          {
            name: 'Coach Adonai',
            link: 'https://www.instagram.com/adonai_boo/',
          },],
        },
        about: '<p><strong>Coach Emmanuel</strong></p><p><strong>Coach Luis Angel</strong></p><p><strong>Coach Adonai</strong></p>',
      },
      {
        id: 'cesar-zamudio',
        name: 'Cesar Zamudio',
        subtitle: 'Baile Fitness',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-baile-fitness.jpg',
        description: 'Ponte en forma al ritmo de la música',
        slug: '/instructores/cesar-zamudio/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-baile-fitness.jpg',
        social: {
          fb: [{
            name: 'Cesar Zamudio',
            link: 'https://www.facebook.com/profile.php?id=100007195514885',
          }],
          ig: [{
            name: 'Cesar Zamudio',
            link: 'https://www.instagram.com/c3sarz4m_b3llas/',
          }],
        },
        about: '',
      },
      {
        id: 'javier-bacilio',
        name: 'Javier Bacilio',
        subtitle: 'Defensa Personal',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-defensa-personal.jpg',
        description: 'Aprende la diferencia entre deportes y situaciones de riesgo',
        slug: '/instructores/javier-bacilio/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-defensa-personal.jpg',
        social: {
          fb: [{
            name: 'Javier Bacilio',
            link: 'https://www.facebook.com/javier.bacilio.5',
          }],
          ig: [{
            name: 'Javier Bacilio',
            link: 'https://www.instagram.com/javierbaciliobacilio/',
          }],
        },
        about: '',
      },
      {
        id: 'guillo-y-kei',
        name: 'Guillo y Kei',
        subtitle: 'Gimnasia',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-gimnasia-02.jpg',
        description: 'Fortalecete y domina tu cuerpo con los mejores tips de gimnasia.',
        slug: '/instructores/guillo-y-kei/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-guillo-y-kei.jpg',
        social: {
          ig: [{
            name: 'kublahkraus',
            link: 'https://www.instagram.com/kublahkraus/',
          },]
        },
        about: '<p><strong>Guillo</strong> es un ex-gimnasta competitivo con más de 16 años en el medio, entrenador profesional a tiempo completo que lidera con pasión durante más de 10 años.</p><p>Experiencia trabajando con niños desde 6 años hasta adultos de 50 años.<br>Experiencia trabajando con atletas no gimnastas como TaeKwonDo, Karate, Cheerleading, HipHop Dancers, Contempo Dancers, Jazz Dancers, Circus Artists y más, ayudándoles a desarrollar condición y acrobacias.</p><p>Especialidad en crear y desarrollar programas de entrenamiento a Nivel principiantes y competitivos, tanto en Gimnasia Varonil cómo Femenil.</p><p>Participación en campeonatos interclubes, estatales, Estatal Elite y nacionales.</p>',
      },
      {
        id: 'juan-carlos-lopez',
        name: 'Juan Carlos López',
        subtitle: 'Danza Jazz',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-danza-jazz.jpg',
        description: 'Vamos a pasar un rato muy agradable practicando Danza Jazz.',
        slug: '/instructores/juan-carlos-lopez/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-juan-carlos-lopez.jpg',
        social: {},
        about: 'Maestro de Danza Jazz.<br><br>Inicia sus estudios de Danza Jazz en Casa de Cultura de Toluca en el año 1998 a las edad de 15 años tomando cursos de coreografía con el maestro Guillermo Arriaga, continua su preparación en el Distrito Federal en academias como "Black Studio", "Danza 3", "Project Dance", "Estudio de Ema Pulido" entre otros.<br><br>Su preparación dancística abarca estudios de Danza Clásica, Danza Contemporánea, Hip Hop y Danza Jazz.<br><br>Algunos de sus Maestros han sido Ricardo Cossio, Lucero Camarena, Serguei Sokolov, Jose Juan Hinojosa, Francisco García Barbara Luna, Jorge Cerezero, Armando Pineda, y entre sus cursos de actualización figuran nombres como Kevin Maher, Roger Lee, Terry Beeman, Sonya Tayeh, Blake McGrath por mencionar algunos.<br><br>La inquietud por la danza lo ha llevado a ser director general de varios espectáculos y competencias en Toluca Estado de México, esto con la finalidad de promover la danza y la cultura en su ciudad; entre dichos eventos destacan el "DID" Día Internacional de la Danza, "Dance Skills" Competencia que reconoce con premios en efectivo y becas a los mejores grupos de danza de la entidad.<br><br> Miembro Fundador de Compañías de danza como "TURN" y "TANZ".<br><br>Actualmente esta a cargo de la Compañía de Danza Actual Representativa del ITESM Campus Toluca, con quienes a Coreografiado proyectos como "Ensambles", Musicales y Competencias producidos por la misma institución.',
      },
      {
        id: 'didack',
        name: 'Didack',
        subtitle: 'Breaking',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-breaking.jpg',
        description: 'Aprende este estilo de danza urbana conocido como breaking, break dance o b-boying/b-girling',
        slug: '/instructores/didack/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-didack.jpg',
        social: {},
        about: '',
      },
      {
        id: 'roberto-parra',
        name: 'Roberto Parra',
        subtitle: 'Fisioterapia',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-fisioterapia.jpg',
        description: 'Aprende qué hacer y qué no hacer cuando tienes una lesión y cómo evitarlas.',
        slug: '/instructores/roberto-parra/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-roberto-parra.jpg',
        social: {},
        about: '',
      },
      {
        id: 'yuri',
        name: 'Yuri',
        subtitle: 'Yoga Kids',
        image: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-yoga-kids.jpg',
        description: 'Diviertete, relajate y juega. Ejercicio para niños de 3 a 99 años',
        slug: '/instructores/yuri/',
        siteFeatured: 'https://s3.amazonaws.com/assets.d-ns.studio/featured-yuri.jpg',
        social: {},
        about: 'Yuri es una instructora certificada por Rainbow Kids Yoga en Yoga for kids and families teacher training.<br><br>Especializada en la enseñanza de Yoga para niños, su experiencia y metodología hacen que los más pequeños encuentren en la Yoga un espacio de relajación mientras se divierten jugando.',
      },
    ];
  }
}
